import { type MetaFunction } from '@remix-run/node';
import { useFetcher } from '@remix-run/react';
import AOS from 'aos';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Clients from '#app/components/clients.tsx';
import Cta from '#app/components/cta.tsx';
import Features02 from '#app/components/features-02.tsx';
import Features03 from '#app/components/features-03.tsx';
import Features04 from '#app/components/features-04.tsx';
import Features05 from '#app/components/features-05.tsx';
import Features from '#app/components/features.tsx';
import Hero from '#app/components/hero.tsx';
import TestimonialsCarousel from '#app/components/testimonials-carousel.tsx';
import Testimonials from '#app/components/testimonials.tsx';

import Footer from '#app/components/ui/footer.tsx';
import Header from '#app/components/ui/header.tsx';

export const meta: MetaFunction = () => [{ title: 'ExploraBit' }];

export default function Index() {
	useEffect(() => {
		AOS.init({
			once: true,
			disable: 'phone',
			duration: 1000,
			easing: 'ease-out-cubic',
		});
	});

	return (
		<>
			<Header />

			<main className="grow">
				<Hero />
				<Clients />
				<Features />
				<Features02 />
				<Features03 />

				<TestimonialsCarousel />
				<Features04 />
				<Features05 />
				<Testimonials />
				<Cta />
			</main>

			<Footer />
		</>
	);
}
